module.exports = __webpack_public_path__ + "img/842.b1a1867e.png";